import React from 'react';
import { useNavigate } from 'react-router';
import { useParams } from "react-router-dom";

const NumberOfTestCases = ({ totalTestCases, testCycleKey }) => {
  const navigate = useNavigate();
  const { projectId } = useParams();

  return (
    <span className='cursor-pointer' onClick={() => navigate(`/project/${projectId}/testcycles/${testCycleKey}?type=testcases`)}>
      {totalTestCases}
    </span>
  );
};

export default NumberOfTestCases;
